import { render, staticRenderFns } from "./Escalate.vue?vue&type=template&id=3e0dc9a3&scoped=true&"
import script from "./Escalate.vue?vue&type=script&setup=true&lang=js&"
export * from "./Escalate.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Escalate.vue?vue&type=style&index=0&id=3e0dc9a3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0dc9a3",
  null
  
)

export default component.exports